<template>
  <div class="page event-management">
    <div class="content">
      <div class="dashboard">
        <heading :title="'My Profile'"></heading>

        <div class="profile">
          <div class="account-info">
            <h1>Account Information</h1>
            <div class="inputs">
              <div class="input">
                <label>Email Address</label>
                <input v-model="user.email" type="email" />
              </div>
              <div class="input">
                <label>New Password</label>
                <input v-model="password" type="password" />
              </div>
              <div class="input">
                <label>Confirm Password</label>
                <input v-model="confirmedPassword" type="password" />
              </div>
              <div class="input">
                <button @click="updateAuth" class="btn">Update</button>
              </div>
            </div>
          </div>
          <div class="contact-info">
            <h1>Contact Information</h1>
            <div class="split-input">
              <div class="input">
                <label>First Name</label>
                <input v-model="user.first_name" type="text" />
              </div>
              <div class="input">
                <label>Last Name</label>
                <input v-model="user.last_name" type="text" />
              </div>
            </div>
            <div class="input">
              <label>Phone Number</label>
              <input v-model="phone_number" type="text" />
            </div>

            <div class="split-input">
              <div class="input">
                <label>Address</label>
                <div v-if="!this.user.address.address_1">
                  <vue-google-autocomplete
                    types=""
                    id="input_address"
                    class="md-layout-item md-size-100"
                    classname="form-control"
                    placeholder="Address"
                    v-on:placechanged="setInput_address"
                    v-on:error="handleError"
                  >
                  </vue-google-autocomplete>
                </div>
                <div v-else>
                  <input v-model="user.address.address_1" type="text" />
                </div>
              </div>
              <div class="input">
                <label>Address 2</label>
                <input v-model="user.address.address_2" type="text" />
              </div>
            </div>
            <div class="split-input">
              <div class="input">
                <label>City</label>
                <input v-model="user.address.city" type="text" />
              </div>
              <div class="input">
                <label>State</label>
                <input v-model="user.address.state" type="text" />
              </div>
            </div>
            <div class="split-input">
              <div class="input">
                <label>Country</label>
                <input v-model="user.address.country" type="text" />
              </div>
              <div class="input">
                <label>Zip</label>
                <input v-model="user.address.zip" type="text" />
              </div>
            </div>
            <div class="input">
              <button @click="handleUpdate" class="btn">Update</button>
            </div>
            <div v-if="error" class="input">
              <p class="error">{{ error }}</p>
            </div>
            <div v-if="success" class="input">
              <p class="success">{{ success }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- import google places api -->
<script
  src="https://maps.googleapis.com/maps/api/js?key=AIzaSyDmxEslCaOETvFzT-EQx10gHIrcAcnSaxw&libraries=places&callback=initAutocomplete"
  async
  defer
></script>

<script>
import firebase from "firebase";
import BtnNav from "@/components/BtnNav.vue";
import managementBar from "@/components/managementBar.vue";
import managementMenu from "@/components/managementMenu.vue";
import Title from "@/components/Title.vue";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import Swal from "sweetalert2";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;
const moment = require("moment");

export default {
  name: "events",
  components: {
    "btn-nav": BtnNav,
    "management-nav": managementBar,
    "side-menu": managementMenu,
    heading: Title,
    VueGoogleAutocomplete,
  },
  data() {
    return {
      event: null,
      progress: "0%",
      userId: null,
      error: null,
      user: {},
      success: null,
      password: null,
      confirmedPassword: null,
    };
  },
  mounted() {
    const userId = auth.currentUser.uid;
    db.collection("user")
      .doc(userId)
      .get()
      .then((res) => {
        const data = res.data();
        this.user = Object.assign({ id: res.id }, data);
      });
  },
  methods: {
    updateAuth() {
      var user = auth.currentUser;

      if (this.confirmedPassword && this.password) {
        if (this.password == this.confirmedPassword) {
          return user
            .updatePassword(this.password)
            .then(() => {
              this.password = null;
              this.confirmedPassword = null;
              return Swal.fire("", "New Password Saved", "success");
            })
            .catch((error) => {
              this.password = null;
              this.confirmedPassword = null;
              return Swal.fire("", error.message, "error");
            });
        } else {
          this.password = null;
          this.confirmedPassword = null;
          return Swal.fire("", "Passwords don't match!", "info");
        }
      }
    },
    setInput_address(input_address, placeResultData, id) {
      this.user.address.address_1 =
        input_address.street_number + " " + input_address.route;
      this.user.address.city = placeResultData.vicinity;
      this.user.address.state = input_address.administrative_area_level_1;
      this.user.address.country = input_address.country;
      this.user.address.zip = input_address.postal_code;
    },
    handleUpdate() {
      const userId = firebase.auth().currentUser.uid;
      db.collection("user")
        .doc(userId)
        .update({
          first_name: this.user.first_name,
          last_name: this.user.last_name,
          phone: this.user.phone_number,
          address: this.user.address,
        })
        .then(() => {
          this.success = "Updated Profile Successfully";
          setTimeout(() => {
            this.success = "";
          }, 3000);
        })
        .catch((err) => {
          this.error = err.message;
        });
    },
    handleError(error) {
      this.error = error.message;
      setTimeout(() => {
        this.error = "";
      }, 3000);
    },
  },
};
</script>

<style lang="scss" scoped>
.profile {
  background-color: #f7f7f7;
  padding: 35px 0px;
  h1 {
    display: block;
    margin: unset;
    padding-bottom: 40px;
  }
  .account-info {
    .inputs {
      display: flex;
      flex-direction: column;
      max-width: 400px;
      flex-wrap: wrap;
      .input {
        width: 100%;
        margin-bottom: 15px;
      }
    }
  }

  .btn {
    margin-top: 10px;
  }
  .contact-info {
    padding-top: 65px;
    max-width: 800px;
    .input {
      width: 48%;
      margin-bottom: 15px;
    }
    .split-input {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
  .success {
    font-weight: bold;
    color: green;
  }
  .error {
    font-weight: bold;
    color: red;
  }
}
</style>

